import { CAP_LABEL, provName } from "./llmUtil";

const esc = (v) => {
  const s = v == null ? "" : String(v);
  const safe = /^[=+\-@\t\r]/.test(s) && !/^-?\d/.test(s) ? `'${s}` : s;
  return /[",\n;]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
};
const n4 = (v) => (v == null ? "" : Number(v).toFixed(4));

// One row per provider × capability (or one provider row when no capability breakdown), with previous-month comparison.
export function spendCsv(cur, prev) {
  const head = ["bulan", "provider", "kapabilitas", "panggilan_sendiri", "panggilan_emergent", "usd_sendiri", "usd_emergent", "anggaran_usd", "persen_anggaran", "bulan_lalu", "usd_sendiri_bulan_lalu", "usd_emergent_bulan_lalu", "selisih_usd", "selisih_persen"];
  const rows = [head];
  const prevBy = Object.fromEntries((prev?.providers || []).map((p) => [p.provider, p]));
  (cur.providers || []).forEach((p) => {
    const pp = prevBy[p.provider];
    const caps = Object.entries(p.by_capability || {});
    const lines = caps.length ? caps.map(([c, v]) => [CAP_LABEL[c] || c, v, pp?.by_capability?.[c]]) : [["(semua)", p, pp]];
    lines.forEach(([cap, v, pv]) => {
      const own = v.usd_own || 0, pOwn = pv ? pv.usd_own || 0 : null;
      const diff = pOwn == null ? "" : n4(own - pOwn);
      const pct = pOwn ? ((own - pOwn) / pOwn * 100).toFixed(1) : "";
      rows.push([cur.month, provName(p.provider), cap, v.calls_own ?? 0, v.calls_emergent ?? 0, n4(own), n4(v.usd_emergent || 0),
        p.budget_usd ?? "", p.budget_pct != null ? Number(p.budget_pct).toFixed(1) : "", prev?.month || "", pv ? n4(pOwn) : "", pv ? n4(pv.usd_emergent || 0) : "", diff, pct]);
    });
  });
  return rows.map((r) => r.map(esc).join(",")).join("\r\n");
}

export function downloadCsv(text, filename) {
  const url = URL.createObjectURL(new Blob(["\ufeff", text], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
